import * as React from "react";
import { components, OptionProps, OptionTypeBase } from "react-select";

export default class OptimizedOption extends React.Component<OptionProps<OptionTypeBase, false>> {
  public render() {
    //@ts-ignore
    delete this.props.innerProps.onMouseMove;
    //@ts-ignore
    delete this.props.innerProps.onMouseOver;

    return <components.Option {...this.props}>{this.props.children}</components.Option>;
  }
}
